import {
  Box,
  TextField,
  Typography,
  Autocomplete,
  Chip,
} from "@mui/material";
import ShepCheckbox from "@/components/GenericComponents/ShepCheckbox";

const ShepMultiCombobox = ({
  title,
  options,
  getLabel,
  checkEquality,
  error,
  helperText,
  displayLimit = -1,
  onChange,
  selectedOptions
}) => {
  const selectAllOptions = [{ key: -1, name: "Select All", all: true }, ...(options)];
  return (
    <Box style={{ display: "flex", flexDirection: "column" }}>
      <Typography
        variant="subheading2"
        sx={{
          paddingBottom: "0.8em",
        }}
      >
        {title}
      </Typography>
      <Autocomplete
        sx={{
          "& .MuiInputBase-root": {
            alignItems: "center",
            flexWrap: "wrap",
            padding: "4px 8px",
            display: "flex",
            height: "auto",
          },
          width: "400px",
          marginRight: "80px",
        }}
        multiple
        disableCloseOnSelect
        id={`mutli-combobox-${title.toLowerCase().replace(' ', '-')}`}
        options={options.length !== 0 ? selectAllOptions : []}
        getOptionLabel={getLabel}
        isOptionEqualToValue={checkEquality}
        renderOption={(optionRenderProps, option, { selected }) => {
          const { key, ...optionProps } = optionRenderProps;
          const isChecked = option.all ? options.length === selectedOptions.length : selected;
          return (
            <li className="test" key={key} {...optionProps}>
              <ShepCheckbox
                edge="start"
                disabled={false}
                checked={isChecked}
                tabIndex={-1}
                disableRipple
                inputProps={{
                  "aria-labelledby":
                    `checkbox-list-label-${title.toLowerCase().replace(' ', '-')}`
                }}
              />
              {getLabel(option)}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={`Select ${title}`}
            placeholder={`Select ${title}`}
            error={error}
            helperText={helperText}
          />
        )}
        renderTags={(value, getTagProps) => {
          const withoutSelectAll = value.filter(option => !option.all);
          return withoutSelectAll.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index: index })
            return <Chip
              key={key}
              label={getLabel(option)}
              {...tagProps}
            />
          })
        }}
        limitTags={displayLimit}
        onChange={onChange}
        value={selectedOptions}
      />
    </Box>
  );
}

export default ShepMultiCombobox;